import React, { Component } from 'react'
import LabelError from '../LabelError'
import Label from '../Label'

export default class InputField extends Component {
  render() {
    const {
      name,
      label,
      error,
      required,
      errorDisabled = false,
      value,
      placeholder,
      type
    }  = this.props

    return (
      
      <div className="flex flex-col justify-start align-top ">
        <Label name={ name } label={ label } type="input" required={ required }/>
        <input 
          type={type} 
          name={name} 
          value={value} 
          placeholder={placeholder} 
          className=" p-2 bg-zinc-100 rounded-lg text-black"
          onChange={this.props.onChange}
        />
        <LabelError error={error} errorDisabled={errorDisabled} name={name} value={value} />
      </div>
    )
  }
}
